import { render, staticRenderFns } from "./SupplierForm.vue?vue&type=template&id=5ece422e"
import script from "./SupplierForm.vue?vue&type=script&lang=js"
export * from "./SupplierForm.vue?vue&type=script&lang=js"
import style0 from "./SupplierForm.vue?vue&type=style&index=0&id=5ece422e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports